import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import styled from 'styled-components'

import Header from "./header"
import "./layout.css"
import "./typographyCss.css"
import Archive from "./archive"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: stretch;
`

const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr;
  margin: 0 auto;
  width: 95%;
  max-width: 100%;
  padding: 0px 1rem 1.5rem;
  flex: 1 0 auto;

  &.grid > * :last-child {
    border-top: 1px solid #888;
  }

  @media (min-width: 1030px) {
    &.grid {
      grid-template-columns: minmax(600px, 2fr) minmax(220px, 1fr);
      grid-gap: 60px;
    }

    &.grid > * :last-child {
      border-top: 0;
    }
  }
`

const Footer = styled.footer`
  margin: 0 auto;
  width: 100%;
  min-width: 300px;
  padding: 0.7rem 1rem;
  background-color: #ccc;
  text-align: center;
`

const Layout = ({ children, withArchive }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            author
          }
        }
      }
    `}
    render={data => {
      const archive = withArchive ? (
        <Archive />) : "";
      const grid = withArchive ? "grid" : ""
      
      return (<Wrapper>
        <Header siteTitle={data.site.siteMetadata.title} />
        <Main className={grid}>
          <div>{children}</div>
          {archive}
        </Main>
        <Footer>
          {data.site.siteMetadata.author} © {new Date().getFullYear()}, 
          Built&nbsp;with&nbsp;
          <a href="https://www.gatsbyjs.org">Gatsby</a>
        </Footer>
      </Wrapper>
    )}}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
